import React from "react";
import { Box } from "@mui/material";
import { useIsMobile } from "src/hooks";
import { desktopFooter } from "./DesktopFooterMenu";
import { mobileFooter } from "./MobileFooterMenu";

interface IProps {
  footerHeight: string;
  backgroundColor?: string;
}

const Footer: React.FC<IProps> = ({
  footerHeight = "100px",
  backgroundColor = "transparent",
}) => {
  const { isMobile, viewName } = useIsMobile();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      className="app_footer"
      color="white"
      // position={isMobile ? "relative" : "fixed"}
      // position={"relative"}
      bottom="0"
      width="100%"
      height={isMobile ? "auto" : footerHeight}
      justifyContent="center"
      sx={{
        borderTop: { xs: "1px solid rgba(234, 32, 32, 0.1)", sm: "none" },
        borderRadius: { xs: "24px 24px 0px 0px", sm: "0" },
        backgroundColor,
      }}
    >
      {isMobile
        ? mobileFooter(backgroundColor)
        : desktopFooter(backgroundColor, viewName)}
    </Box>
  );
};

export default Footer;
